const orderTranslation = {
  frequentlyAskedQuestionsText1: "Preguntas Frecuentes",
  frequentlyAskedQuestionsText2: "Tengo un problema con la entrega del pedido...",
  frequentlyAskedQuestionsText3: "Por favor contacte a Bidscape para recibir asistencia.",
  frequentlyAskedQuestionsText4: "Algunos de los artículos del pedido que garanticé ya no están en inventario...",
  frequentlyAskedQuestionsText5: "Por favor contacte a Bidscape lo antes posible para informarnos de cualquier artículo que faltará en el pedido.",
  frequentlyAskedQuestionsText6: "El cliente está rechazando un artículo por calidad o debido a un error...",
  frequentlyAskedQuestionsText7: "En caso de error, por favor organice un intercambio por el producto correcto o notifique a Bidscape para emitir reembolsos.",
  frequentlyAskedQuestionsText8: "El cliente me está contactando DESPUÉS de que la entrega ya se realizó para solicitar una devolución o intercambio de uno o varios artículos?",
  frequentlyAskedQuestionsText9: "Bidscape no permite devoluciones o intercambios después de que la entrega ya se haya realizado.",

  orderText1: "Fecha de Entrega:",
  orderText2: "Por determinar (entrega por fases)",
  orderText3: "Fecha de Recogida:",
  orderText4: "Destino:",
  orderText5: "Para el pago, por favor contacte a",
  orderText6: "***Por favor no entregue un recibo o precios al cliente. Solo boleta de entrega.***",
  orderText7: "Artículos del Pedido",
  orderText8: "cada uno",
  orderText9: "Subtotal:",
  orderText10: "Cargo de Entrega:",
  orderText11: "Total:",
  orderText12: "Volver",
  orderText13: "Foto",
  orderText14: "Notas del Pedido:",

  orderQueryErrorText1: "Ocurrió un error al cargar su pedido, asegúrese de tener conexión a internet o contacte a Heather en",
  orderQueryErrorText2: "Ocurrió un error al cargar su pedido, contacte a Heather en",
  orderQueryErrorText3: "para asistencia.",
  orderQueryErrorText4: "Volver",
  orderQueryErrorText5: "Intentar de nuevo",

  // Order Confirmation
  orderConfirmationText1: "Error al Cargar el Pedido",
  orderConfirmationText2: "Error al cargar los datos de confirmación del pedido",
  orderConfirmationText3: "Ir al Panel",
  orderConfirmationText4: "Revisar Artículos",
  orderConfirmationText5: "Resumen del Pedido",
  orderConfirmationText6: "Todos los artículos marcados como agotados",
  orderConfirmationText7: "cada uno",
  orderConfirmationText8: "Cant:",
  orderConfirmationText9: "Subtotal",
  orderConfirmationText10: "Enviando Pedido...",
  orderConfirmationText11: "Confirmar Pedido",
  orderConfirmationText12: "Complete los términos de entrega para enviar",
  orderConfirmationText13: "Revisar Todos los Artículos",
  orderConfirmationText14: "Por favor revise y confirme o cambie todos los artículos antes de proceder con el pedido.",
  orderConfirmationText15: "Tamaño:",
  orderConfirmationText16: "Nombre Latino:",
  orderConfirmationText17: "Nombre Común:",
  orderConfirmationText18: "Cantidad:",
  orderConfirmationText19: "Agotado",
  orderConfirmationText20: "Precio cambiado",
  orderConfirmationText21: "Cerrar",
  orderConfirmationText22: "Precio Actual:",
  orderConfirmationText23: "¿Cuál es el nuevo precio?",
  orderConfirmationText24: "Cancelar",
  orderConfirmationText25: "Confirmar Precio",
  orderConfirmationText26: "Confirmado",
  orderConfirmationText27: "Sin confirmar",
  orderConfirmationText28: "Agotado",
  orderConfirmationText29: "Precio Cambiado",
  orderConfirmationText30: "Cambiado",
  orderConfirmationText31: "Desconocido",
  orderConfirmationText32: "¡Oh no!",

  orderConfirmationHeaderText1: "Por favor revise el siguiente pedido pendiente. Una vez que proporcione confirmación de disponibilidad, seguirá una orden de compra. ¿Preguntas? Contacte a",
  orderConfirmationText33: "Notas:",

  // Order Confirmation Notifications
  orderConfirmationSuccessTitle: "¡Pedido Confirmado!",
  orderConfirmationSuccessMessage: "Su confirmación de pedido ha sido enviada exitosamente",
  orderConfirmationErrorTitle: "Error",
  orderConfirmationErrorMessage: "Ocurrió un error al confirmar su pedido",
};

export default orderTranslation; 